import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const createOrUpdateFromRetsListing = async ({
  shouldCreateCopy,
  retsListingId,
  updates,
}: {
  shouldCreateCopy: boolean;
  retsListingId: string;
  updates: Record<string, any>;
}) => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `/rets/listing/${retsListingId}`,
    data: { shouldCreateCopy, updates },
  };

  const { data: newId } = await axios.request<string>(config);

  return newId;
};

export default createOrUpdateFromRetsListing;
